import { SiteContainer, SiteMockSlot } from '../SiteUi';

const CARDS = [
  {
    title: 'Retorno',
    line: 'Chegou o período configurado? O WhatsApp sai.',
    visual: (
      <SiteMockSlot className="bg-[#ece5dd]">
        <p className="rounded bg-white px-2 py-2 text-xs text-[#16181d]">Que tal agendar seu retorno?</p>
      </SiteMockSlot>
    ),
  },
  {
    title: 'Cobrança',
    line: 'Título venceu? A cobrança sai.',
    visual: (
      <SiteMockSlot tone="dark">
        <p>OS-1038 · Marina</p>
        <p className="mt-1 font-os text-[#f5821f]">R$ 420,00 vencido</p>
      </SiteMockSlot>
    ),
  },
  {
    title: 'Pós-atendimento',
    line: 'OS terminou? O NPS sai.',
    visual: (
      <SiteMockSlot tone="dark">
        <p>De 0 a 10, recomendaria?</p>
        <p className="mt-2 font-os tracking-[0.3em] text-white/50">0 1 2 … 10</p>
      </SiteMockSlot>
    ),
  },
  {
    title: 'Fiscal',
    line: 'Venda finalizada? A nota é processada.',
    visual: (
      <SiteMockSlot tone="dark">
        <p>NFC-e 000182</p>
        <p className="mt-1 text-[#7dcea0]">autorizada</p>
      </SiteMockSlot>
    ),
  },
];

export function SiteAutopilot() {
  return (
    <section className="bg-[#0e1a28] py-20 text-white sm:py-28">
      <SiteContainer>
        <h2 className="max-w-[14ch] font-display text-[clamp(2.25rem,5vw,4rem)] font-semibold leading-[1.02] tracking-tight">
          Algumas coisas simplesmente acontecem.
        </h2>
        <div className="mt-14 grid items-stretch gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {CARDS.map((card) => (
            <article key={card.title} className="flex flex-col">
              {card.visual}
              <h3 className="mt-5 font-display text-xl font-semibold">{card.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/65">{card.line}</p>
            </article>
          ))}
        </div>
      </SiteContainer>
    </section>
  );
}
